module.exports = __webpack_public_path__ + "img/screenshot (2).0d5cd81b.jpg";